import { type MCPServerInfo } from '../../types';

const HerokuServer: MCPServerInfo = {
  serverId: 'HEROKU',
  name: 'Heroku',
  slug: 'heroku',
  description: 'Heroku Platform MCP Server using the Heroku CLI.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/heroku:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['herokuApiKey'],
    properties: {
      herokuApiKey: {
        type: 'string',
        description: 'heroku APIKey',
        sensitive: true
      }
    }
  }
};

export default HerokuServer;
